export default __webpack_public_path__ + "static/firebase-95825b374574c19c92c6ffbeaa7d2c68.png";